import styled from 'styled-components';
import { COLORS } from '../../styles/variables';

export const OuterContainer = styled.div`
  .ReactCollapse--collapse {
    transition: height 300ms;
  }
  margin-bottom: 2px;
`;

export const Container = styled.button`
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: ${COLORS.white};
  min-height: 50px;
  width: 100%;
  box-shadow: 0px 1px 2px rgba(0, 0, 0, 0.25);
  border: none;
  font-family: 'Audi Type';
  font-size: 13px;
  line-height: 30px;
  z-index: 10;
  cursor: pointer;
`;

export const Heading = styled.h6`
  margin-right: 12px;
  font-weight: 500;
  color: ${COLORS.black};
`;
